<template>
  <div>
    <div v-if="!loading">
      <div class="vx-row" v-for="contract in contracts" :key="contract.id">
        <div class="vx-col ml-auto mr-auto lg:w-1/2 w-full m-base">
          <vx-card
            :title="contract.contract_name"
            :no-shadow="!contract.active"
            :card-background="!contract.active ? '#eeeeee' : ''"
            :content-color="!contract.active ? '#9e9e9e' : ''"
          >
            <contract-info :contract="contract" class="mb-base"></contract-info>
            <contract-mail-settings
              class="mb-base"
              :contract="contract"
            ></contract-mail-settings>
            <div class="vx-row" v-if="contract.active">
              <div class="vx-col mb-4 w-full xl:w-1/3">
                <vs-button
                  color="primary"
                  type="border"
                  class="w-full"
                  @click="() => showDetailsPopup(contract.id)"
                  >Zie prijsopbouw</vs-button
                >
              </div>

              <div class="vx-col mb-4 w-full xl:w-1/3">
                <vs-button
                  color="primary"
                  class="w-full"
                  type="border"
                  @click="() => showAdjustPopup(contract.id)"
                  >Klopt mijn termijnbedrag nog?</vs-button
                >
              </div>
              <div
                class="vx-col mb-4 w-full xl:w-1/3"
                v-if="
                  contract.contract_type == 1 || contract.contract_type == 2
                "
              >
                <vs-button
                  color="success"
                  class="w-full"
                  type="border"
                  @click="
                    showChangeContractPopup = true;
                    selectedContractId = contract.id;
                  "
                  >Verander contract</vs-button
                >
              </div>
              <div class="vx-col mb-4 w-full xl:w-1/3">
                <vs-button
                  color="primary"
                  class="w-full"
                  type="border"
                  :to="`contracts/${contract.id}/rehousing`"
                  >Verhuizing doorgeven</vs-button
                >
              </div>
              <div class="vx-col mb-4 w-full xl:w-1/3">
                <vs-button
                  color="danger"
                  class="w-full"
                  type="border"
                  @click="() => showCancellationPopup(contract.id)"
                  >Contract opzeggen</vs-button
                >
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-popup
      title="Contract veranderen"
      :active.sync="showChangeContractPopup"
    >
      <change-contract
        v-if="showChangeContractPopup"
        :id.sync="selectedContractId"
      />
    </vs-popup>
    <vs-popup
      title="Klopt mijn termijnbedrag nog?"
      :active.sync="adjustPopupActive"
      :fullscreen="advise != null && advise.show_advise > 0"
    >
      <form v-on:submit.prevent="adjustRecurringAmount">
        <div v-if="!popupLoading">
          <div v-if="advise != null">
            <div class="vx-row">
              <div class="vx-col mb-2 ml-auto mr-auto">
                <recurring-amount-advise
                  :advise="advise"
                  :current="contractDetails.recurring_payment.total_incl_vat"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="vx-row" v-if="customerStatus != null">
              <div class="vx-col mb-2 ml-auto mr-auto" v-if="!success">
                <h5>Termijnbedrag handmatig aanpassen</h5>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-2 ml-auto mr-auto" v-if="!success">
                <vs-input
                  label-placeholder="Termijnbedrag"
                  v-model="newAmount"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-2 ml-auto mr-auto" v-if="!success">
                <span
                  class="text-danger text-sm"
                  v-if="amountErrors['request.Amount']"
                  >{{ amountErrors["request.Amount"][0] }}</span
                >
              </div>
            </div>
            <div class="vx-row">
              <div
                class="vx-col ml-auto mr-auto"
                v-if="!success && !sentLoading"
              >
                <vs-button
                  button="submit"
                  color="success"
                  class="ml-4"
                  type="filled"
                  >Aanpassen</vs-button
                >
              </div>
            </div>
          </div>

          <div class="vx-col" v-if="success">
            <vs-alert color="success" title="Verstuurd" active="true">
              We hebben je verzoek binnengekregen om het termijnbedrag aan te
              passen. Je ontvangt bericht wanneer het daadwerkelijk is
              aangepast.
            </vs-alert>
          </div>
        </div>
      </form>
    </vs-popup>

    <vs-popup title="Contract opzeggen" :active.sync="cancellationPopupActive">
      <form v-on:submit.prevent="cancelContract">
        <validation-observer ref="cancelContractObserver">
          <div v-if="!success">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-2 ml-auto mr-auto">
                <label for="" class="vs-input--label">Opzegging per*</label>
                <datepicker
                  placeholder="Selecteer datum"
                  v-model="outbound_reason.end_date"
                  :format="customFormatter"
                  :disabled-dates="disabled_dates"
                ></datepicker>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-2 ml-auto mr-auto">
                <vs-alert
                  color="warning"
                  v-if="
                    outbound_reason_day_difference != null &&
                      outbound_reason_day_difference < 30
                  "
                >
                  Er geldt een opzegtermijn van 30 dagen. Als je je contract
                  binnen deze periode wilt opzeggen, dan dien je een boete te
                  betalen.
                </vs-alert>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-2 ml-auto mr-auto" v-if="!success">
                <ValidationProvider
                  :name="'Reden voor opzegging'"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-select
                    placeholder="Selecteer een reden"
                    label="Reden voor opzegging*"
                    label-placeholder="Reden voor opzegging"
                    v-model="outbound_reason.reason_id"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.description"
                      v-for="(item, index) in outbound_reasons"
                    />
                  </vs-select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-2 ml-auto mr-auto">
                <vs-alert
                  color="warning"
                  v-if="
                    selected_outbound_reason != null &&
                      selected_outbound_reason.warning != null
                  "
                >
                  {{ selected_outbound_reason.warning }}
                </vs-alert>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-2 ml-auto mr-auto">
                <vs-textarea
                  label="Toelichting (optioneel)"
                  v-model="outbound_reason.explanation"
                  width="400px"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col ml-auto mr-auto">
                <vs-button
                  button="submit"
                  color="danger"
                  class="ml-4"
                  type="filled"
                  >Opzeggen</vs-button
                >
              </div>
            </div>
          </div>

          <div class="vx-col" v-if="success">
            <vs-alert color="success" title="Verstuurd" active="true">
              We hebben je verzoek binnengekregen je contract op te zeggen. Je
              ontvangt hier zo snel mogelijk een bevestiging van in je mail.
            </vs-alert>
          </div>
        </validation-observer>
      </form>
    </vs-popup>

    <vs-popup title="Prijsopbouw" :active.sync="detailsPopupActive">
      <div v-if="!popupLoading">
        <table class="mb-base">
          <tr>
            <th></th>
            <th>Hoeveelheid</th>
            <th>Prijs</th>

            <th>Totaal</th>
          </tr>
          <tr
            v-for="contractDetail in contractDetails.rules"
            :key="contractDetail.description"
          >
            <th style="text-align: right;">{{ contractDetail.description }}</th>

            <td style="text-align: center;">
              {{ contractDetail.volume }} {{ contractDetail.unit }}
            </td>
            <td>
              <money-format
                v-if="contractDetail.unit_price"
                :value="contractDetail.unit_price"
                locale="nl"
                currency-code="EUR"
                :subunit-value="true"
                :hide-subunits="false"
                :supplementalPrecision="3"
              />
            </td>
            <th style="text-align: right;">
              <money-format
                :value="contractDetail.total_incl_vat"
                locale="nl"
                currency-code="EUR"
                :subunit-value="true"
                :hide-subunits="false"
              >
              </money-format>
            </th>
          </tr>
          <tfoot>
            <tr>
              <th style="text-align: right;">Totaal</th>
              <th style="text-align: right;" colspan="3">
                <money-format
                  :value="contractDetails.recurring_payment.total_incl_vat"
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"
                >
                </money-format>
              </th>
            </tr>
          </tfoot>
        </table>
        <p
          style="text-align: right;"
          v-html="contractDetails.disclaimer_text"
        ></p>
        <p style="font-size: 10px; text-align: right;">
          Er kunnen afrondingsverschillen voorkomen in de totaalprijs.
          Overheidstoeslagen (BTW, Energiebelasting, ODE en Vermindering
          Energiebelasting) en netwerkkosten worden conform regel- en wetgeving
          verrekend.
        </p>
        <sun-burst-graph :data="contractDetails.sun_burst_data" />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "../axios";
import MoneyFormat from "vue-money-format";
import SunBurstGraph from "../components/graph/SunBurstGraph.vue";
import contractInfo from "@/components/contractInfo.vue";
import ContractMailSettings from "@/components/ContractMailSettings.vue";
import changeContract from "@/components/contracts/changeContract.vue";
import RecurringAmountAdvise from "@/components/contracts/recurringAmountAdvise.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {
  ValidationObserver,
  extend,
  localize,
  ValidationProvider
} from "vee-validate";
import { required, numeric, regex } from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";

extend("numeric", numeric);
extend("required", required);
extend("regex", regex);
localize("nl", nl);
export default {
  data() {
    return {
      loading: false,
      detailsPopupActive: false,
      cancellationPopupActive: false,
      popupLoading: true,
      adjustPopupActive: false,
      contractDetails: {},
      contractIdPopup: 0,
      newAmount: 0,
      amountErrors: {},
      cancellationErrors: {},
      success: false,
      sentLoading: false,
      possibleContractChanges: [],
      showChangeContractPopup: false,
      selectedContractId: 0,
      advise: null,
      outbound_reasons: [],
      outbound_reason: {
        reason_id: null,
        end_date: moment()
          .add(30, "days")
          .toDate(),
        explanation: null
      },
      disabled_dates: {
        to: moment().toDate()
      }
    };
  },
  components: {
    MoneyFormat,
    SunBurstGraph,
    contractInfo,
    changeContract,
    ContractMailSettings,
    RecurringAmountAdvise,
    Datepicker,
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    ...mapState(["customerStatus", "contracts", "actions"]),
    selected_outbound_reason() {
      return this.outbound_reasons.find(
        r => r.id == this.outbound_reason.reason_id
      );
    },
    outbound_reason_day_difference() {
      if (this.outbound_reason.end_date != null) {
        let end_date = moment(this.outbound_reason.end_date);
        return end_date.diff(moment(), "days") + 1;
      }
      return null;
    }
  },
  async created() {
    await this.getOutboundReasons();
  },
  methods: {
    async showAdjustPopup(contractId) {
      this.amountErrors = {};
      this.adjustPopupActive = true;
      this.popupLoading = true;
      this.success = false;
      this.contractIdPopup = contractId;
      this.advise = null;
      await this.getContractDetails(contractId);

      if (this.customerStatus != null) {
        let baseOnCurrentEac = this.baseOnCurrentEac
          ? this.baseOnCurrentEac
          : this.contractDetails.has_conventional_meter &&
            this.contractDetails.contract_type != 4 &&
            !this.contractDetails
              .has_sent_recurring_amount_advise_metering_recently;
        await this.getAdvise(this.contractDetails.id, baseOnCurrentEac);
      }

      this.newAmount = this.contractDetails.recurring_payment.total_incl_vat
        .toString()
        .replace(".", ",");
      this.popupLoading = false;
    },
    async showCancellationPopup(contractId) {
      this.cancellationErrors = {};
      this.cancellationPopupActive = true;
      this.success = false;
      this.contractIdPopup = contractId;
    },
    async showDetailsPopup(contractId) {
      this.detailsPopupActive = true;
      this.popupLoading = true;
      await this.getContractDetails(contractId);
      this.popupLoading = false;
    },
    async getOutboundReasons() {
      let response = await axios().get(`/api/Contracts/outbound_reasons`);
      this.outbound_reasons = response.data;
    },
    async getAdvise(contractId, baseOnCurrentEac) {
      let response = await axios().get(
        `/api/contracts/${contractId}/advised_recurring_amount?baseOnCurrentEac=${baseOnCurrentEac}`
      );
      this.advise = response.data;
    },
    async adjustRecurringAmount() {
      try {
        this.sentLoading = true;
        await axios().put("/api/contracts/recurring_amount", {
          contract_id: this.contractIdPopup,
          amount: this.newAmount.replace(",", ".")
        });
        this.success = true;
      } catch (err) {
        this.amountErrors = err.response.data;
      }
      this.sentLoading = false;
    },
    async cancelContract() {
      await this.$refs.cancelContractObserver.validate();

      await axios().post("/api/Contracts/end_contract", {
        ...this.outbound_reason,
        contract_id: this.contractIdPopup
      });
      this.success = true;
    },

    async getContractDetails(contractId) {
      let response = await axios().get(`/api/contracts/${contractId}`);
      this.contractDetails = response.data;
    },

    async getPossibleContractChanges(contractId) {
      let response = await axios().get(
        `/api/contracts/${contractId}/possible_contract_changes`
      );
      return response.data;
    },
    customFormatter(date) {
      return moment(date)
        .locale("nl")
        .format("DD-MM-YYYY");
    }
  }
};
</script>

<style></style>
